module.exports = __webpack_public_path__ + "img/mga.f69ceccd.svg";